/**
 * Informations centralisées du Chantilly Club
 * Mise à jour automatique des horaires et informations essentielles
 */

// Horaires du club principal
export const clubHours = {
  weekdays: {
    days: "Lundi - Vendredi",
    hours: "08h00 - 00h00"
  },
  weekends: {
    days: "Samedi & Dimanche", 
    hours: "09h00 - 20h00"
  }
};

// Horaires commandes en ligne (restaurant & proshop)
export const onlineOrderHours = {
  weekday: "Lun–Ven : 11h–14h30 et 17h–23h",
  weekend: "Sam–Dim : 11h–14h30 et 17h–19h",
  summary: "Commandes en ligne : 11h–14h30 et 17h–23h (sem.) · 17h–19h (we)",
};

// Horaires du restaurant SNACKING (sur place)
export const restaurantHours = {
  weekdays: {
    days: "Lundi - Vendredi",
    hours: "11h00-14h30 & 17h00-23h00"
  },
  weekends: {
    days: "Samedi & Dimanche",
    hours: "11h00-14h30 & 17h00-19h00"
  }
};

// Informations des coachs avec calcul automatique d'expérience
const calculateExperience = (startDate) => {
  const currentDate = new Date();
  const start = new Date(startDate);
  let years = currentDate.getFullYear() - start.getFullYear();
  
  // Ajustement si l'anniversaire n'est pas encore passé cette année
  if ((currentDate.getMonth() < start.getMonth()) || 
      (currentDate.getMonth() === start.getMonth() && currentDate.getDate() < start.getDate())) {
    years--;
  }
  
  return Math.max(1, years); // Minimum 1 an
};

export const coaches = [
  {
    id: 1,
    firstName: "Jean-Alexandre",
    lastName: "Willem",
    fullName: "Jean-Alexandre Willem",
    specialty: "Padel & Basketball",
    startDate: "2023-01-01", // Début 2023
    experienceYears: calculateExperience("2023-01-01"),
    experience: `${calculateExperience("2023-01-01")} ${calculateExperience("2023-01-01") === 1 ? 'an' : 'ans'} d'expérience`,
    certifications: ["BPJEPS APT (obtenu 2022)", "En formation TFP (en cours)"],
    available: true,
    image: "https://sportiw.com/storage/avatars/22556_avatar_0859fbb3.png",
    phone: "+33 6 XX XX XX XX",
    email: "jeanalexandre.coach@chantillyclub.fr"
  },
  {
    id: 2,
    firstName: "Jean-Bastien",
    lastName: "Willem",
    fullName: "Jean-Bastien Willem",
    specialty: "Padel & Basketball",
    startDate: "2024-01-01", // Début 2024
    experienceYears: calculateExperience("2024-01-01"),
    experience: `${calculateExperience("2024-01-01")} ${calculateExperience("2024-01-01") === 1 ? 'an' : 'ans'} d'expérience`,
    certifications: ["En formation TFP (en cours)"],
    available: true,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face",
    phone: "+33 6 YY YY YY YY",
    email: "jeanbastien.coach@chantillyclub.fr"
  }
];

// Informations de contact
export const contactInfo = {
  address: {
    street: "1 Rue Hoche",
    city: "59491 Villeneuve-d'Ascq",
    country: "France"
  },
  phones: {
    main: "+33 9 85 00 85 00",
    whatsapp: "+33 6 86 68 91 03"
  },
  emails: {
    general: "lechantillyclub@gmail.com",
  },
  parking: {
    type: "Parking privé gratuit",
    capacity: "100 places disponibles", 
    access: "Accès sécurisé 24h/24"
  }
};

// Statistiques du club
export const clubStats = [
  { number: "15+", label: "Sports & Activités", icon: "Target", color: "text-yellow-400" },
  { number: "12", label: "Terrains Premium", icon: "Trophy", color: "text-green-400" },
  { number: "7j/7", label: "Ouvert", icon: "Clock", color: "text-blue-400" },
  { number: "5★", label: "Satisfaction Client", icon: "Star", color: "text-purple-400" }
];

// Services spécialisés
export const services = [
  {
    id: 'padel',
    title: 'PADEL',
    subtitle: 'Le sport qui cartonne !',
    courts: 'Terrains padel (compteur dynamique via admin)',
    speciality: 'Indoor & Outdoor'
  },
  {
    id: 'restaurant',
    title: 'SNACKING',
    subtitle: 'Restauration & Terrasse',
    speciality: 'Vue forêt panoramique',
    menu: 'Pizzas, croque-monsieur, boissons'
  },
  {
    id: 'loisirs', 
    title: 'LOISIRS',
    subtitle: 'Flippers, pétanque, billard...',
    speciality: '2500m² de divertissement',
    activities: '20 flippers + pétanque + billard'
  }
];

export default {
  clubHours,
  restaurantHours,
  coaches,
  contactInfo,
  clubStats,
  services
};